<script setup lang="ts">
import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useApiStore } from "@/stores/api";
import SchemaInfoCard from "@/components/task-pane/SchemaInfoCard.vue";

const apiStore = useApiStore();
const { apiEntries } = storeToRefs(apiStore);

const visibleUrls = computed(() =>
  Array.from(apiEntries.value.entries())
    .filter(([, entry]) => entry.state === "loaded" || entry.state === "loading")
    .map(([url]) => url)
);

const loadingUrls = computed(() =>
  Array.from(apiEntries.value.entries())
    .filter(([, entry]) => entry.state === "loading")
    .map(([url]) => url)
);

const loadedUrls = computed(() =>
  Array.from(apiEntries.value.entries())
    .filter(([, entry]) => entry.state === "loaded")
    .map(([url]) => url)
);

function getApiName(url: string): string {
  const entry = apiEntries.value.get(url);
  if (entry && typeof entry.item === "object") {
    return entry.item.name;
  }
  return url;
}
</script>

<template>
  <v-card elevation="0" flat>
    <v-card-text>
      <div v-for="url in loadingUrls" :key="`loading-${url}`" class="mb-4">
        <v-card elevation="0" border>
          <v-card-title class="d-flex align-center">
            <v-progress-circular indeterminate size="16" width="2" class="mr-2 flex-shrink-0" />
            <span class="text-truncate">Loading {{ getApiName(url) }}...</span>
          </v-card-title>
          <v-card-text>
            <v-skeleton-loader type="text, text, chip" :loading="true" />
          </v-card-text>
        </v-card>
      </div>

      <div v-for="url in loadedUrls" :key="url">
        <SchemaInfoCard class="mb-4" :url="url" />
      </div>

      <v-card v-if="visibleUrls.length === 0" class="text-center pa-3" elevation="0" border>
        <v-icon size="48" color="grey"> mdi-checkbox-multiple-blank-outline </v-icon>
        <v-card-title>Nothing available yet</v-card-title>
        <v-card-subtitle>Choose one or more items from the top to begin.</v-card-subtitle>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<style scoped></style>
